export const footer = {
  mode: "ko",
  footer: {
    seldiInformation:
      "셀디 | 서울시 강남대로364 미왕빌딩 1709 | 대표 : 이창헌 | 사업자등록번호 : 568-88-02012",
    seldiNumber: "전화 : 02-6958-8556 | 팩스 : 0504-051-2750",
    consultingTitle: "상담문의",
    consultingTime: `평일  09:00-18:00(점심 11:30-12:30)
    토/일/공휴일 휴무`,
  },
};
